import { motion } from "framer-motion";
import { getFormEntriesByFormName } from "../services/formServices";
import { useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { FORMNAMES } from "../utilities/codes";
import { schoolContext } from "../contexts/SchoolContextProvider";
import { mediaSource } from "../utilities/mediautilities"
import { useTranslation } from "react-i18next"
import { I18N_KEYS } from "../languages/PlaceHolder.js";

const Approach = () => {
    const [approaches, setApproaches] = useState([]);
    const { schoolDetails } = useContext(schoolContext);
    const { t } = useTranslation()

    useEffect(() => {
        getApproaches();
    }, [])

    const getApproaches = async () => {
        try {
            const response = await getFormEntriesByFormName(FORMNAMES.SCHOOLAPPROACH);
            setApproaches(response);
        } catch (error) {
            toast.error(error.message);
        }
    }

    return (
        <>
            {approaches?.length > 0 &&
                <section className="py-24 bg-gray-50 px-6">
                    <h2 className="text-4xl font-bold text-primary text-center">
                        {t(I18N_KEYS.APPROACHTITLE)}
                    </h2>
                    <p className="text-primary mt-2 mb-10 text-center">
                        {schoolDetails?.approach_subtitle && schoolDetails?.approach_subtitle}
                    </p>

                    <div className="flex flex-wrap justify-center gap-4 md:gap-10 common-container">
                        {approaches?.map((approach, i) => (
                            <motion.div
                                key={i}
                                initial={{ scale: 0.8, opacity: 0 }}
                                whileInView={{ scale: 1, opacity: 1 }}
                                transition={{ delay: i * 0.2, type: "spring", stiffness: 120 }}
                                whileHover={{ scale: 1.12 }}
                                className="w-28 h-28 sm:w-40 sm:h-40 md:w-60 md:h-60 bg-accent rounded-full shadow-2xl flex flex-col items-center justify-center text-center cursor-pointer"
                            >
                                <div className="text-2xl sm:text-3xl md:text-5xl mb-2 md:mb-4 w-[25%] h-[25%]">
                                    <img
                                        src={mediaSource(approach?.payload?.image?.fileUrl)}
                                        alt={`${approach?.payload?.title}`}
                                        className="w-[100%] h-[100%]"
                                        onError={(e) => mediaSource(e)}
                                    />
                                </div>
                                {approach?.payload?.title &&
                                    <h3 className="font-semibold text-primary text-xs sm:text-sm md:text-lg px-2">
                                        {approach?.payload?.title}
                                    </h3>
                                }
                            </motion.div>
                        ))}
                    </div>

                </section>
            }
        </>
    )
}

export default Approach;